<template>
  <section class="vehicles-form">
    <embed-frame
      class="vehicles-form-frame"
      placeholder="Carregando..."
      :endpoint="embedEndpoint"
      :settings="embedSettings"
      :callbacks="embedCallbacks"
    />
  </section>
</template>

<script>
  import EmbedFrame from '@sdk/views/Embed/Frame.vue';

  export default {
    name: 'VehiclesForm',
    components: {
      EmbedFrame,
    },
    computed: {
      importing() {
        return !!this.$route.query.import;
      },

      embedEndpoint() {
        return this.importing ? 'vehicles/import' : 'vehicles/form';
      },
      embedSettings() {
        return {
          vehicles: {
            form: {
              id: this.$route.params.id,
            },
          },
        };
      },
      embedCallbacks() {
        return {
          'vehicle:read': this.read,

          'vehicle:create': this.callback,
          'vehicle:update': this.callback,

          'vehicle:import': this.imported,
        };
      },
    },
    mounted() {
      this.$store.dispatch('usedVehicles/clear', { action: 'read' });
    },
    methods: {
      read(data) {
        this.$store.dispatch('usedVehicles/readForce', data.vehicle);
      },

      callback() {
        this.$router.push({
          name: 'vehicles-list',
        });
      },

      imported() {
        // this.$router.push({
        //   name: 'vehicles-read',
        //   params: {
        //     id: data.vehicle.id,
        //   },
        // });

        this.$router.push({
          name: 'vehicles-list',
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .vehicles-form {
    padding: 0 var(--product--pwa--horizontal);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      padding: 0 var(--product--pwa--horizontal);
    }
  }
</style>
